import React from 'react'
import {LoggedRoute} from '@freckle/student/ts/common/routers/logged-route'
import type {PathData} from './path-data'
import {
  ScienceReadingAssignmentHandler,
  ScienceWritingAssignmentHandler,
  SocialStudiesReadingAssignmentHandler,
  SocialStudiesWritingAssignmentHandler,
} from './unit-lazy'

export type UnitRoutesWithQueryParams = {
  '/science/assignments/reading/:assignmentIds': undefined
  '/science/assignments/writing/:assignmentIds': undefined
  '/social-studies/assignments/reading/:assignmentIds': undefined
  '/social-studies/assignments/writing/:assignmentIds': undefined
}

export const unitPathData: PathData<UnitRoutesWithQueryParams> = {
  '/science/assignments/reading/:assignmentIds': {
    isBlockedByFocusMode: false,
    element: path => <LoggedRoute component={ScienceReadingAssignmentHandler} path={path} />,
  },
  '/science/assignments/writing/:assignmentIds': {
    isBlockedByFocusMode: false,
    element: path => <LoggedRoute component={ScienceWritingAssignmentHandler} path={path} />,
  },
  '/social-studies/assignments/reading/:assignmentIds': {
    isBlockedByFocusMode: false,
    element: path => <LoggedRoute component={SocialStudiesReadingAssignmentHandler} path={path} />,
  },
  '/social-studies/assignments/writing/:assignmentIds': {
    isBlockedByFocusMode: false,
    element: path => <LoggedRoute component={SocialStudiesWritingAssignmentHandler} path={path} />,
  },
}
